export default __webpack_public_path__ + "static/media/pepsico.3a3173dc.png";